import '../chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TimeMetricChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/time_metric/time_metric_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'time_metric'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    @title = I18n.t('customer_visual_mode.charts.time_metrics_chart.title')
    @description = I18n.t('customer_visual_mode.charts.average_handle_after_assigned_time.description')
    super({widget, @title, @description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_timeMetricViews().forEach (view) =>
      @$('.time-metric-chart').append(
        view.render().el
      )
      @listenTo(view, 'timeMetricCard:click', @_openDrilldown)
    @

  _timeMetricViews: ->
    [
      @_averageHandleAfterAssignedTimeView()
    ]

  _averageHandleAfterAssignedTimeView: ->
    averageValue = 0
    sum = @data.sum_handle_after_assigned_time_value
    count = @data.sum_handle_after_assigned_time_count
    if count && sum
      averageValue = sum / count
    @averageHandleAfterAssignedTimeView ||= new CustomerVisualMode.Charts.TimeMetricCardView(
      value: averageValue
      clickable: true
      iconClass: 'status-icon'
      dimension: 'average_handle_after_assigned_time'
      statusClass: 'average-handle-after-assigned-time'
      title: I18n.t('customer_visual_mode.charts.average_handle_after_assigned_time.title')
    )

  _openDrilldown: (dimension) ->
    super({
      dimensions: [dimension],
      name: 'Average handle time',
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    })
